import { WalletPayment } from '@aaa-ncnu-ie/mypolicy-api-billing';

/**
 * `WalletPayment` is a discriminated union: a card account exposes `card`, a
 * bank account exposes `account`. These accessors narrow the union so callers
 * can read the relevant sub-object without hand-rolling `'card' in payment`
 * checks at every site.
 */
/**
 * The fully-typed card / bank-account payloads, extracted from the matching arm
 * of the `@aaa-ncnu-ie/mypolicy-api-billing` `WalletPayment` union. Derived
 * straight from the union — no re-declaration of the shapes and no direct
 * dependency on `@aaa-ncnu-ie/digital-client-soa-wallet` (the billing package's
 * types already carry them transitively).
 */
export type WalletCard = Extract<WalletPayment, { card: unknown }>['card'];
export type WalletAccount = Extract<
  WalletPayment,
  { account: unknown }
>['account'];

export const getWalletCard = (
  payment?: WalletPayment | null
): WalletCard | undefined =>
  payment && 'card' in payment ? payment.card : undefined;

export const getWalletAccount = (
  payment?: WalletPayment | null
): WalletAccount | undefined =>
  payment && 'account' in payment ? payment.account : undefined;
